var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingRequest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2,
    fill: "url(#pending_request_svg__a)",
    stroke: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5.801,
    width: 4.813,
    height: 0.947,
    rx: 0.474,
    fill: "#000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 4.813,
    height: 0.947,
    rx: 0.474,
    fill: "#000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 4.813,
    height: 0.947,
    rx: 0.474,
    fill: "#000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.8,
    y: 4.801,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "url(#pending_request_svg__b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11.211C7 10.542 7.556 10 8.241 10h.518c.685 0 1.241.542 1.241 1.211v.578C10 12.458 9.444 13 8.759 13H8.24C7.556 13 7 12.458 7 11.789v-.578zm1.241-.403a.409.409 0 00-.413.403v.578c0 .223.185.403.413.403h.518c.228 0 .413-.18.413-.403v-.578a.409.409 0 00-.413-.403H8.24zM6.8 6.012c0-.669.556-1.211 1.241-1.211h.517c.686 0 1.242.542 1.242 1.211v.577c0 .67-.556 1.212-1.242 1.212h-.517C7.356 7.8 6.8 7.258 6.8 6.589v-.577zm1.241-.404a.409.409 0 00-.414.404v.577a.41.41 0 00.414.404h.517c.229 0 .414-.18.414-.404v-.577a.409.409 0 00-.414-.404h-.517zM7 16.212C7 15.542 7.556 15 8.241 15h.518c.685 0 1.241.542 1.241 1.212v.576C10 17.459 9.444 18 8.759 18H8.24C7.556 18 7 17.458 7 16.788v-.576zm1.241-.404a.409.409 0 00-.413.404v.576c0 .224.185.404.413.404h.518c.228 0 .413-.18.413-.404v-.576a.409.409 0 00-.413-.404H8.24z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pending_request_svg__a",
    x1: 10.787,
    y1: -4.777,
    x2: -4.665,
    y2: 8.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pending_request_svg__b",
    x1: 8.04,
    y1: 3.505,
    x2: 5.447,
    y2: 6.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF684A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4959"
  })))));
}
export default SvgPendingRequest;